export default __webpack_public_path__ + "static/media/Group 115.fb3fc460.svg";